import { VideoUrl } from '../types/banner/video-url';

export const isVideoUrlField = (value: unknown): value is VideoUrl => {
  return typeof value === 'object' && value !== null && 'originalUrl' in value;
};

export const processVideoUrls = <T>(config: object, processor: (videoUrl: VideoUrl) => T | null): T[] => {
  const results: T[] = [];

  Object.values(config as Record<string, unknown>).forEach(fieldValue => {
    if (isVideoUrlField(fieldValue)) {
      const result = processor(fieldValue);
      if (result !== null) results.push(result);
    } else if (Array.isArray(fieldValue)) {
      fieldValue.forEach(item => {
        if (isVideoUrlField(item)) {
          const result = processor(item);
          if (result !== null) results.push(result);
        }
      });
    }
  });

  return results;
};
